var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"observerElement",staticClass:"banner-brow"},_vm._l((_setup.columnLayoutList),function(layoutItem,index){return _c(_setup.BannerList,{key:index,attrs:{"bannerList":layoutItem.bannerlist,"columnType":layoutItem.columnType}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }